import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-gray-800 dark:text-red-400 absolute bottom-0 mx-auto z-50",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "flex-shrink-0 inline w-5 h-5 mr-3",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = { class: "font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300 transform",
      "enter-from-class": "opacity-0 translate-y-10 scale-95",
      "enter-to-class": "opacity-100 translate-y-0 scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-from-class": "opacity-100 translate-y-0 scale-100",
      "leave-to-class": "opacity-0 translate-y-10 translate-y-0 scale-95"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.info')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.error')) + ": ", 1),
            _createTextVNode(_toDisplayString(_ctx.message) + ". ", 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}